<template>
  <main>
    <container class="lg:pt-12 pb-24">
      <div id="home"
          class="animate__animated animate__fadeInDown w-full mx-auto flex flex-col overflow-hidden-x">
        <content-component :order1lg="'order-2'" :order2lg="'order-1'" :order1sm="'order-1'" :order2sm="'order-2'">
          <template #slot1 >
            <h1 class="text-4xl font-bold">
              <span class="text-blue-600">Ajudo você</span> <br>
              a descobrir a real causa das suas dores físicas
            </h1>
            <p class="text-xl font-normal mt-6">
              melhore de forma simples, rápida e sem dor.
            </p>
            <div class="w-full lg:gap-x-4 flex flex-col lg:flex-row  justify-start mt-12">
              <secondary-button title="Saiba mais" target="" link="#biancaEluisa"/>
              <primary-button title="Agende uma pré consulta gratuita">
              </primary-button>
            </div>
          </template>
          <template #slot2>
            <img src="../../public/head.png" alt="Dr. Bianca Eluisa" width="858" height="719" class="mt-12 lg:mt-0">
          </template>
        </content-component>
      </div>
    </container>
  </main>
</template>
<script>
import Container from "@/components/partials/Container.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import SecondaryButton from "@/components/buttons/SecondaryButton.vue";
import ContentComponent from "@/components/partials/Content.vue";

export default {
  name: 'MainComponent',
  components: {
    ContentComponent,
    Container,
    PrimaryButton,
    SecondaryButton
  }
}
</script>